import * as React from 'react';
import { EEventType } from '../../types/events';
import { isEmail, isValidPhone } from '../../utils/validation';
import { ViewContainer } from '../ViewContainer';
import { TitleContainer } from '../TitleContainer';
import { ESubtitleOffset, SubtitleLayout } from '../../components/SubtitleLayout';
import { TwoFactorAttemptsExhausted } from '../../components/TwoFactorAttemptsExhausted';
import { trackTwoFactorAttemptsExhaustedSupportClick } from '../../utils/tracking';
import { ETwoFactorType } from '../../types/authentication';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function TwoFactorAttemptsExhaustedViewContainer(_ref) {
  var login = _ref.login,
    phone = _ref.phone,
    changeLogin = _ref.changeLogin,
    reset = _ref.reset,
    emit = _ref.emit;
  var contactQuery = React.useMemo(function () {
    return [isEmail(login) ? "email=".concat(encodeURIComponent(login)) : null, phone && isValidPhone(phone) ? "phone=".concat(encodeURIComponent("+".concat(phone.replace(/\D+/g, '')))) : null, 'twoFactor=true'].filter(Boolean).join('&');
  }, [login, phone]);
  var handleSupportClick = React.useCallback(function () {
    emit(EEventType.TwoFactorAttemptsExhaustedSupportClick);
    trackTwoFactorAttemptsExhaustedSupportClick(phone ? ETwoFactorType.Phone : ETwoFactorType.Email);
    window.open("/contacts/?".concat(contactQuery), '_blank');
  }, [contactQuery, emit, phone]);
  var handleBackClick = React.useCallback(function () {
    reset();
    changeLogin(login);
  }, [changeLogin, login, reset]);
  return /*#__PURE__*/_jsxs(ViewContainer, {
    children: [/*#__PURE__*/_jsx(TitleContainer, {}), /*#__PURE__*/_jsx(SubtitleLayout, {
      offset: ESubtitleOffset.XL,
      children: "\u041F\u0440\u0435\u0432\u044B\u0448\u0435\u043D\u043E \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u0435 \u043D\u0430 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043F\u043E\u043F\u044B\u0442\u043E\u043A \u0432\u0432\u043E\u0434\u0430 \u043F\u0440\u043E\u0432\u0435\u0440\u043E\u0447\u043D\u043E\u0433\u043E \u043A\u043E\u0434\u0430. \u041D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u0432 \u0441\u043B\u0443\u0436\u0431\u0443 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438 \u0434\u043B\u044F \u0440\u0435\u0448\u0435\u043D\u0438\u044F \u044D\u0442\u043E\u0439 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u044B."
    }), /*#__PURE__*/_jsx(TwoFactorAttemptsExhausted, {
      onSupport: handleSupportClick,
      onCancel: handleBackClick
    })]
  });
}